<div id="progress" *ngIf="state" >
  <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>

<div id="data_avail" *ngIf="data_avail" >
  <p>Data not available</p>
</div>

<div class="heading">
  <header>
    Mars Rover Photos
  </header>
</div>
<div class="toggle">
  <mat-form-field appearance="fill"  style="padding-right: 10px; padding-left: 10px; color: blanchedalmond">
    <mat-label>Rover</mat-label>
    <mat-select [(ngModel)]="currentRover">
      <mat-option [value]="j.key" *ngFor="let j of cameras | keyvalue">{{ j.key }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" style="padding-right: 10px; padding-left: 10px; color: blanchedalmond">
    <mat-label>Camera</mat-label>
    <mat-select [(ngModel)]="currentCamera">
      <mat-option [value]="c.value" *ngFor="let c of cameras[currentRover] | keyvalue">{{ c.value }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="fill" style="padding-right: 10px; padding-left: 10px; color: white">
    <mat-label>Sol</mat-label>
    <input type="number" matInput [(ngModel)]="sol">
  </mat-form-field>
</div>

<div class="send">
  <button mat-button (click)="getPhotos()"><p style="color: white; margin-bottom: 0%;">Apply</p></button>
</div>

<div class="photos" *ngIf="!state">
  <mat-card *ngFor="let p of photos">
    <img mat-card-image (click)="showFullImage(p)" src="{{ p['img_src'] }}" title="Click for see full size image">
    <mat-card-content> <b>Date:</b> {{ p['earth_date'] }}</mat-card-content>
    <mat-card-content> <b>Camera:</b> {{ p['camera']['full_name'] }}</mat-card-content>
  </mat-card>
</div>
